import { Context, Effect } from "effect";
import type { Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { KVAction, KVSettlement, KVSnapshot } from "./model.ts";

export interface KVSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<KVSnapshot>>;
  readonly settlements: Effect.Effect<readonly KVSettlement[]>;
  readonly dispatch: (action: KVAction) => Effect.Effect<void>;
}
export class KVSessions extends Context.Service<KVSessions, {
  readonly explorer: Effect.Effect<KVSession, never, Scope.Scope>;
  readonly browse: Effect.Effect<KVSession, never, Scope.Scope>;
}>()("workerstation/frontend/KVSessions") {}
